// Feature flags. Each defaults OFF.
// Two sources (docs/specs/runtime-flags.md):
//   1. Build env: only the exact string "true" turns a REACT_APP_* flag on. CRA bakes these in at build time.
//   2. Node, at runtime: src/index.js asks GET /config/client-flags before the first render and calls
//      applyClientFlags(). The UAT build has no REACT_APP_* env (Kiran keeps env on the backend), so this is its source.
// A flag is on if either source says on. `export let` + applyClientFlags before render: every reader reads the
// binding at render time, so it sees node's value.
const env = (name) => process.env[name] === "true";

const ENV = {
  mfaLoginV2: env("REACT_APP_MFA_LOGIN_V2"),
  // docs/specs/password-reset-stepup.md: Forgot/Change Password on step-up + /mfa/password/reset (Phase 7b).
  passwordResetV2: env("REACT_APP_PASSWORD_RESET_V2"),
  // docs/specs/login-setup.md: phone + authenticator setup at sign-in, and the method order.
  loginSetup: env("REACT_APP_LOGIN_SETUP"),
  // Retired — never turn on (docs/specs/login-setup.md "What it replaces"). Env only; node never sends it.
  smsFactor: env("REACT_APP_SMS_FACTOR"),
};

export let MFA_LOGIN_V2 = ENV.mfaLoginV2;
export let PASSWORD_RESET_V2 = ENV.passwordResetV2;
// Effective only with MFA_LOGIN_V2.
export let SMS_FACTOR = MFA_LOGIN_V2 && ENV.smsFactor;
// Effective only with MFA_LOGIN_V2.
export let LOGIN_SETUP = MFA_LOGIN_V2 && ENV.loginSetup;

// `remote` is node's answer, or null when it failed. Only a real `true` counts; anything else is off.
export const applyClientFlags = (remote) => {
  const fromNode = (key) => remote !== null && typeof remote === "object" && remote[key] === true;
  MFA_LOGIN_V2 = ENV.mfaLoginV2 || fromNode("mfa_login_v2");
  PASSWORD_RESET_V2 = ENV.passwordResetV2 || fromNode("password_reset_v2");
  SMS_FACTOR = MFA_LOGIN_V2 && ENV.smsFactor;
  LOGIN_SETUP = MFA_LOGIN_V2 && (ENV.loginSetup || fromNode("login_setup"));
};
